export const downloadFile = (url: string, fileName?: string): void => {
  const element = document.createElement("a");
  element.href = url;
  element.download = fileName || "";
  element.click();
};
